import _classCallCheck from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/createClass.js";
/* eslint-disable */
import { deepMix, each } from '@antv/util';
import { createDom } from '@antv/dom-util';
var AddItemPanel = /*#__PURE__*/function () {
  function AddItemPanel(cfgs) {
    _classCallCheck(this, AddItemPanel);
    this._cfgs = deepMix(this.getDefaultCfg(), cfgs);
  }
  _createClass(AddItemPanel, [{
    key: "getDefaultCfg",
    value: function getDefaultCfg() {
      return {
        container: null
      };
    }
  }, {
    key: "get",
    value: function get(key) {
      return this._cfgs[key];
    }
  }, {
    key: "set",
    value: function set(key, val) {
      this._cfgs[key] = val;
    }
  }, {
    key: "initPlugin",
    value: function initPlugin(graph) {
      var parentNode = this.get('container');
      var ghost = createDom('<img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"' + ' style="opacity:0"/>');
      var children = parentNode.querySelectorAll('div > .el-collapse-item > .el-collapse-item__wrap > .el-collapse-item__content > img[data-item]');
      each(children, function (child, i) {
        var addModel = new Function("return " + child.getAttribute('data-item'))();
        child.addEventListener('dragstart', function (e) {
          e.dataTransfer.setDragImage(ghost, 0, 0);
          graph.set('addNodeDragging', true);
          graph.set('addModel', addModel);
        });
        child.addEventListener('dragend', function (e) {
          graph.emit('canvas:mouseup', e);
          graph.set('addNodeDragging', false);
          graph.set('addModel', null);
        });
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.get('canvas').destroy();
      var container = this.get('container');
      container.parentNode.removeChild(container);
    }
  }]);
  return AddItemPanel;
}();
export default AddItemPanel;